import React from 'react';
let resolution = window.RESOLUTION;
if(window.innerWidth >= 1920 && window.innerHeight >= 1080){resolution = "FHD";}else{resolution = "HD";}
const userAgent = navigator.userAgent.toLowerCase();
if (userAgent.includes('webos') || userAgent.includes('lg') || userAgent.includes('web0s')) {
resolution = 'FHD';
}
const ToastScreen = ({disply, msg, toastBgColor}) => {
    const styles = {
        ToastScreenContainer: {
          display: disply,
          flexDirection: 'column',
          background: 'transparent'  ,
          width: '100vw',
          height: '100vh',    
          backgroundSize: 'cover',
          backgroundPosition: 'center', // Center the background image
          backgroundRepeat: 'no-repeat', // Do not repeat the background image
          opacity: 0.8,
          overflow: 'hidden'
        },
      };
  return (
    <div style={styles.ToastScreenContainer}>    
      <div style={{display: 'flex', position: 'absolute', width: '50vw', height: '10vh', background: toastBgColor, borderRadius: '10px', alignItems: 'center',
                   justifyContent: 'center', marginLeft: '25vw', marginTop: '5vh', fontSize: '32px', color: '#FFFFFF', fontWeight: 'bold'}}>{msg}</div>
    </div>
  );
};
export default ToastScreen;